import { RootState } from '../Application';
import { isConfigReady } from '../domain/Config/Conditions';
import { app } from '../initApp';
import { Condition } from '../screen/Condition';
import { UseCase } from './usecase/UseCase';

export const showSportsStepUseCase:UseCase = {
  type: 'SHOW_SPORTS_STEP',

  checkConditions: ( state: RootState ) => {
    return Condition.evaluate(state, [isConfigReady]);
  },

  run: () => {
    // @ts-ignore
    return Cx.resolve();
  }
};

export function canShowSportsStep(state: RootState) {
  return showSportsStepUseCase.checkConditions( state ).isAllowed;
}

export function showSportsStep(){
  app.runUseCase(showSportsStepUseCase);
}
